<edu-card>
  <h4 edu-card-title>Recommended Action Plan</h4>
  <h4 edu-card-subtitle *ngIf="studentName">{{username}} - {{studentName}}</h4>

  <div class="plan-container">
    <div *ngIf="sortedIssues.length === 0" class="no-issues">
      <p>No issues to display</p>
    </div>

    <ul class="plan-timeline">
      <li *ngFor="let issue of sortedIssues" class="plan-item" [class.completed]="isIssueCompleted(issue.id)">
        <div class="timeline-connector">
          <div class="timeline-dot" [style.backgroundColor]="getPriorityColor(issue.priority)"></div>
        </div>

        <div class="issue-content">
          <div class="issue-header">
            <div class="issue-title-row">
              <span class="issue-title">{{ issue.title }}</span>
              <!-- <span class="issue-category">{{ issue.category }}</span> -->
            </div>

            
          </div>

          <div class="issue-progress-container" *ngIf="issue.todoItems && issue.todoItems.length > 0">
            <h5 class="todo-title">Action Items</h5>
            <ul class="todo-list">
              <li *ngFor="let todoItem of issue.todoItems; let i = index" class="todo-item"
                [class.completed]="todoItem.completed">
                <div class="todo-main-item light-form">
                  <mat-checkbox color="primary" [disabled]="this.readonly" [id]="'todo-' + issue.id + '-' + i"
                    [checked]="todoItem.completed" (change)="toggleTodoCompletion(issue.id, i)"
                    [labelPosition]="'after'">
                    {{ todoItem.title }}
                  </mat-checkbox>
                </div>

                <!-- Sub-items section -->
                <div class="todo-subitems-container" *ngIf="todoItem.subItems && todoItem.subItems.length > 0">
                  <ul class="sub-items-list light-form">
                    <li *ngFor="let subItem of todoItem.subItems; let j = index" class="sub-item"
                      [class.completed]="subItem.completed">
                      <mat-checkbox [disabled]="this.readonly" color="primary"
                        [id]="'sub-' + issue.id + '-' + i + '-' + j" [checked]="subItem.completed"
                        (change)="toggleSubItemCompletion(issue.id, i, j)" [labelPosition]="'after'">
                        {{ subItem.title }}
                      </mat-checkbox>
                    </li>
                  </ul>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </li>
    </ul>
  </div>
</edu-card>